export const BOTTOM_NAV_HEIGHT = 56 // px — matches BottomTabNav min-h-[56px]
